var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "h-100",
      attrs: { id: "application-form" },
      on: {
        change: _vm.saveOnType,
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.saveOnType.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "col-12 h-100", attrs: { id: _vm.currentPage } },
        [
          _c("keep-alive", [
            _c(
              "div",
              [
                _c(_vm.currentPageComponent, {
                  key: _vm.nonce,
                  tag: "component",
                  attrs: {
                    "edit-visibility": _vm.editVisibility,
                    "is-brokerage": _vm.isBrokerage,
                    "current-application": _vm.CURRENT_APPLICATION,
                    "application-id": _vm.applicationId,
                    "client-username": _vm.clientUsername,
                    "agent-username": _vm.agentUsername,
                    "client-details": _vm.clientDetails,
                  },
                  on: {
                    "page-change": _vm.handlePageChange,
                    save: _vm.saveOnType,
                    "direct-save": _vm.saveApplication,
                    refresh: _vm.handleRefresh,
                    "toggle-visibility": _vm.handleVisibility,
                    replicate: _vm.saveOnType,
                    "open-life-insurance-modal":
                      _vm.handleOpenLifeInsuranceModal,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("life-insurance-modal", {
            ref: "lifeInsuranceModal",
            attrs: { "client-username": _vm.clientUsername },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }